export const en = {
    'combinator-tab': 'Keyword Generator',
    'manual-input-tab': 'Manual input'
};
